import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
         <p>Designed & developed with ❤️ by Adrian Petersson</p>   
        </div>
    )
}

export default Footer
